import { useState, useEffect, useRef } from "react";
import { useAppSelector } from "../store/hooks";
import { ActiveTabEnum } from "../enums";
import { store } from "../store/store";

interface UsePageVisible {
  hasLostFocus: boolean;
}

export const usePageVisible = (): UsePageVisible => {
  const [isPageVisible, setIsPageVisible] = useState(true);
  const isPageTabInterrupt = useAppSelector(
    (state) => state.tab.isBrowserTabOrWindowInterrupt
  );
  const notVisibleDuration = useRef(0);

  useEffect(() => {
    if (isPageTabInterrupt) {
      notVisibleDuration.current = 0;
    }
  }, [isPageTabInterrupt]);

  useEffect(() => {
    const visibilityListener = (): void => {
      if (
        store.getState().tab.activeTab === ActiveTabEnum.DRAW &&
        (store.getState().tab.drawStarted ||
          store.getState().tab.shouldSpinWheel)
      ) {
        if (document.visibilityState === "visible") {
          notVisibleDuration.current =
            new Date().getTime() - notVisibleDuration.current;
          setIsPageVisible(true);
        } else {
          setIsPageVisible(false);
          notVisibleDuration.current = new Date().getTime();
        }
      }
    };
    window.addEventListener("visibilitychange", visibilityListener);

    return () => {
      window.removeEventListener("visibilitychange", visibilityListener);
    };
  }, []);

  return {
    hasLostFocus: isPageVisible && notVisibleDuration.current / 1000 > 15,
  };
};
